import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { kaiTypographyWeb } from '../../../typography';
import { REVIEW_COLORS, REVIEW_RADII, REVIEW_SPACING } from '../reviewFlowTokens';
import {
  resolveStyleOverride,
  type StyleOverride,
} from '../styleOverrides';

export interface TabProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: ReactNode;
  selected?: boolean;
  trailing?: ReactNode;
  styleOverride?: StyleOverride;
}

export const Tab = forwardRef<HTMLButtonElement, TabProps>(
  (
    {
      label,
      selected = false,
      trailing,
      styleOverride: tabCss,
      style,
      type = 'button',
      ...props
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: REVIEW_SPACING.small,
          minHeight: 28,
          padding: `${REVIEW_SPACING.xSmall}px ${REVIEW_SPACING.medium}px`,
          border: `1px solid ${selected ? REVIEW_COLORS.toolbar : REVIEW_COLORS.border}`,
          borderRadius: REVIEW_RADII.pill,
          background: selected ? REVIEW_COLORS.toolbar : 'transparent',
          color: selected ? REVIEW_COLORS.textInverse : REVIEW_COLORS.textMuted,
          cursor: 'pointer',
          appearance: 'none',
          ...kaiTypographyWeb.xSmallMed,
          whiteSpace: 'nowrap',
          ...style,
          ...resolveStyleOverride(tabCss),
        }}
        {...props}
      >
        <span>{label}</span>
        {trailing ? <span>{trailing}</span> : null}
      </button>
    );
  },
);

Tab.displayName = 'Tab';
